import { connect } from 'react-redux';
import { fetchFile, deleteFile } from '../../../store/modules/file';

import File from '../components/File';

const mapActionCreators = {
  fetchFile,
  deleteFile,
};

const mapStateToProps = state => ({
  file: state.file.files[state.file.current],
  files: state.file.files,
  fetching: state.file.fetching,
  limits: state.limits.limits,
});

export default connect(mapStateToProps, mapActionCreators)(File);



// WEBPACK FOOTER //
// ./src/routes/File/containers/FileContainer.js